import React, { useContext, useEffect } from 'react';

import { useSelector } from '../../../../../selectors/useSelector';
import actions from '../../../../../containers/CreateListingPage/actions';
import { ModularListingContext } from '../../../../../containers/CreateListingPage/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../../constants/WizardConstants';
import { TYPES_MAP } from '../../../../../constants/ListingCriteriaConstants';

import WizardAlert from '../../../../WizardAlert';
import IncomeToRentRatioFormField from '../../../FinancialExpectations/components/IncomeToRentRatioFormField';

import type { CriterionProps } from '../../../../../model/ListingCriteria/Criterion';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../../styles/wizard';

const inputField = TYPES_MAP.INCOME_TO_RENT;

const MinimumIncomeRatioFormSectionContainer = () => {
  const {
    modularListingState: { serverErrorObj },
    reducerDispatch,
  } = useContext(ModularListingContext);

  const criteria = useSelector((state) => state.properties.currentProperty.listingCriteria.criteria);

  const incomeToRentRatioMax = criteria.find((criterion: CriterionProps) => criterion.type === inputField)?.max;

  useEffect(() => {
    actions.updateAnyProperty({
      reducerDispatch,
      data: {
        isInModalState: true,
        isSaveComplete: false,
        shouldSaveOnBlur: false,
      },
    });

    return () => actions.updateShouldSaveOnBlur({ reducerDispatch, shouldSaveOnBlur: true });
  }, [reducerDispatch]);

  return (
    <WizardFormSectionContainer data-testid="MinimumIncomeRatioFormSectionContainer">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />

      <WizardHeading level={1} textStyle="heading-sm">
        What&apos;s your preferred income-to-rent ratio?
      </WizardHeading>

      <WizardBody>
        This will be displayed on your listing and used to help you review prospective renters, so you can quickly see
        who’s a good fit for your property.
      </WizardBody>

      <IncomeToRentRatioFormField label="Minimum income-to-rent ratio" incomeToRentRatioMax={incomeToRentRatioMax} />
    </WizardFormSectionContainer>
  );
};

export default MinimumIncomeRatioFormSectionContainer;
